import { gql } from "@apollo/client";

export const GET_HOME_TODO_OVERVIEW = gql`
  query HomeTodoOverview($params: HomeTodoOverviewParams) {
    homeTodoOverview(params: $params) {
      summary {
        deductionCount
        totalAmount
        disputeNeededAmount
        groupCount
      }
      groups {
        categoryKey
        categoryName
        description
        entryCriteria
        exitCriteria
        sequence
        deductionCount
        totalAmount
      }
    }
  }
`;
